const ROOT_API = process.env.VUE_APP_ROOT_API;

const GET_LEASE = ROOT_API + 'get_lease.php';
const GET_JOURNAL_LPO = ROOT_API + 'get_journal_lpo.php';
const GET_POINT_LIST = ROOT_API + 'get_lease_points.php';

import router from '@/router';
import fetchData from '@/lib/fetchData';
import processJSON from '@/lib/processJSON';

export default {

	state: {
		lease: null
	},

	mutations: {
		setLease(state, payload) {
			state['lease'] = payload;
		},

		clearLease(state, payload) {
			state['lease'] = null;
		}
	},

	actions: {
		getLeaseAll(context, payload) {
			

			const { state, commit, dispatch } = context;

			const lease_id = payload;

			return dispatch('getLease', lease_id).then(res => {
				dispatch('getPointList');
			}).catch(err => { throw err; });
		},	

		getLease(context, payload) {
			
			const { state, rootState, commit, dispatch } = context;

			// console.log(rootState);
			// return;

			const lease_id = rootState.lpoData.currentLpo.lease_id;
			
			const form = new FormData();
			form.append('lease_id', lease_id);

			return fetch(GET_LEASE, {
				credentials: 'include',
				method: 'post',
				body: form
			})
			.then(res => res.json())
			.then(res => {
				commit('setLease', res);
			})
			.catch(err => { throw err; });
		},	

		updateLease(context, payload) {
			const { state, dispatch } = context;
			dispatch('getLease', state.lease.id);
		},

		createLeaseInCreatedLpo(context, payload) {
			console.log('create lease in created lpo');
		},

		saveGeneralValue(context, payload) {
			const { state } = context;

			const valueList = payload;

			const f_v_rest = {};
			for (const item of valueList) {
				f_v_rest[item.field] = item.value;
			}

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo_lease',
							'f_v': {
								'id': state['lease'].id,
								...f_v_rest
							}
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		}

	}
};